import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fb9eb21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-wrapper-28" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", null, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#checkmark-28" })
], -1))
const _hoisted_4 = { for: "tmp-28" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("symbol", {
    id: "checkmark-28",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      fill: "none",
      d: "M22.9 3.7l-15.2 16.6-6.6-7.1"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: "tmp-28",
      type: "checkbox",
      checked: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCheckChange($event as InputEvent))),
      class: "promoted-input-checkbox"
    }, null, 40, _hoisted_2),
    _hoisted_3,
    _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.label), 1),
    _hoisted_5
  ]))
}